import { defineStore } from 'pinia'
import { getWishlist } from '@/api/wishlist'

export const useWishlistStore = defineStore('wishlist', {
  state: () => ({
    wishlist: [],
    paginatedWishlist: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      limit: 24
    }
  }),
  getters: {},
  actions: {
    async fetchWishlist(params = { all: true }) {
      const data = await getWishlist(params)
      if (params.all) {
        this.wishlist = data.wishlists
      } else {
        this.paginatedWishlist = data.wishlists || []
        if (data.pagination) {
          this.pagination = {
            ...this.pagination,
            ...data.pagination
          }
        }
      }
    },
    addToWishlist(newWishItem) {
      if (this.wishlist) {
        this.wishlist = [...this.wishlist, newWishItem]
      }
      if (this.paginatedWishlist) {
        this.paginatedWishlist = [...this.paginatedWishlist, newWishItem]
      }
    },
    removeFromWishlist(wishListID) {
      if (this.wishlist) {
        const filteredArray = this.wishlist.filter(wishlist => wishlist.id !== wishListID)
        this.wishlist = [...filteredArray]
      }
      if (this.paginatedWishlist) {
        const filteredArray = this.paginatedWishlist.filter(wishlist => wishlist.id !== wishListID)
        this.paginatedWishlist = [...filteredArray]
      }
    }
  }
})
